import React from 'react';
import Link from 'next/link';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faChevronLeft} from '@fortawesome/free-solid-svg-icons';

const BRDPartnerTermsNotice = (props) => {
    const {goBack} = props;

    return (
        <Container>
            <Row>
                <Col className="p-3">
                    <p>
                        In vederea indeplinirii obiectului contractului dintre Conso Media Grup SRL (Conso) si BRD, aceasta din urma are obligatia de a transmite catre Conso anumite informatii despre identitatea dvs, valoarea. si statusul creditului pentru care v-ati exprimat interesul prin prezentul formular.
                    </p>

                    <p>Temeiul prelucrarii: consimtămantul dvs (Art. 6 alin. 1 lit. (a) GDPR).</p>

                    <p>
                        In cazul in care nu sunteti de acord cu transmiterea acestor informatii, BRD nu va putea da curs cererii dvs. legate de acordarea creditului.
                    </p>

                    <p>
                        Va puteti retrage consimtamantul in orice moment ulterior acordarii, insa nu mai tarziu de momentul contactarii dvs. de catre BRD.
                    </p>

                    <p>
                        Bifand aceasta optiune, sunteti de acord ca numele, prenumele dvs., status solicitarii si valoarea creditului sa ne fie comunicate de catre BRD in scopul mentionat mai sus.
                    </p>

                    <Button variant="outline-secondary" onClick={goBack}>
                        <FontAwesomeIcon icon={faChevronLeft} height="16" width="16" className="me-2"/>
                        Înapoi
                    </Button>
                </Col>
            </Row>
        </Container>
    );
}

export default BRDPartnerTermsNotice;

